module.exports = __webpack_public_path__ + "img/clientes.fbc020ad.png";